import { Tag, Tooltip } from "antd"
import { AmazonDataState } from "../types/project"

interface NotAvailableTagProps {
  amazonDataState: AmazonDataState
  tooltipText: string
}

const NotAvailableTag: React.FC<NotAvailableTagProps> = ({ amazonDataState, tooltipText }) => {
  return (
    <Tooltip title={tooltipText}>
      <Tag color={amazonDataState === AmazonDataState.NOT_IN_AMAZON ? "red" : "orange"}>
        {amazonDataState}
      </Tag>
    </Tooltip>
  )
}

export default NotAvailableTag
